import { Route, Routes } from 'react-router-dom';

import { CreateReport } from './pages/createReport';
import { EditReport } from './pages/editReport';
import { ListReport } from './pages/listReport';
import { ReportTabs } from './pages/reportTabs';
import { ReportVersion } from './pages/reportVersion';

export const ReportsAdministration = () => {
  return (
    <>
      <div>
        <Routes>
          <Route index element={<ListReport />} />
          <Route path="create" element={<CreateReport />} />
          <Route path="versions" element={<ReportVersion />} />
          <Route path=":reportId/:tab" element={<ReportTabs />} />
          <Route path=":id" element={<EditReport />} />
        </Routes>
      </div>
    </>
  );
};
